
const TechnicalTeam = () => {
  return (
    <div className="space-y-8">
      <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-lg p-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">
          Our Technical Team Will Handle Your Request
        </h3>
        <p className="text-gray-700 mb-6">
          Golden Black's expert engineers and technical specialists are standing by to analyze 
          your requirements and provide comprehensive solutions tailored to your specific needs.
        </p>
        
        <div className="space-y-4">
          <div className="flex items-start space-x-3">
            <div className="w-6 h-6 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <i className="ri-time-line text-white text-sm"></i>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900">Rapid Response</h4>
              <p className="text-gray-600 text-sm">Initial response within 24 hours</p>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <div className="w-6 h-6 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <i className="ri-user-star-line text-white text-sm"></i>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900">Expert Analysis</h4>
              <p className="text-gray-600 text-sm">Detailed technical evaluation by specialists</p>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <div className="w-6 h-6 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <i className="ri-settings-3-line text-white text-sm"></i>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900">Custom Solutions</h4>
              <p className="text-gray-600 text-sm">Tailored recommendations for your operations</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-lg p-6">
        <h3 className="text-xl font-bold text-gray-900 mb-4">Contact Information</h3>
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            <i className="ri-phone-line text-teal-600 text-lg"></i>
            <span className="text-gray-700">+971 56 276 1272</span>
          </div>
          <div className="flex items-center space-x-3">
            <i className="ri-mail-line text-teal-600 text-lg"></i>
            <span className="text-gray-700">goldenblack@chemsolutionservice.live</span>
          </div>
          <div className="flex items-center space-x-3">
            <i className="ri-map-pin-line text-teal-600 text-lg"></i>
            <span className="text-gray-700">UAE Chemical Solutions Hub</span>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-3">What to Expect</h3>
        <ul className="space-y-2 text-sm text-gray-600">
          <li className="flex items-start space-x-2">
            <span className="text-teal-600 font-bold">1.</span>
            <span>Technical team reviews your requirements</span>
          </li>
          <li className="flex items-start space-x-2">
            <span className="text-teal-600 font-bold">2.</span>
            <span>Initial consultation call or meeting</span>
          </li>
          <li className="flex items-start space-x-2">
            <span className="text-teal-600 font-bold">3.</span>
            <span>Detailed proposal with technical specifications</span>
          </li>
          <li className="flex items-start space-x-2">
            <span className="text-teal-600 font-bold">4.</span>
            <span>Implementation planning and support</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TechnicalTeam;
